export const removeAccents = (str: string): string => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[đĐ]/g, "d")
    .replace(/[âÂ]/g, "a")
    .replace(/[êÊ]/g, "e")
    .replace(/[.,:"'<>?`!@#$%^&*();/\\]/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase()
}

export const isSlugUnique = async (slug: string, checkSlugApi: (slug: string) => Promise<any>): Promise<boolean> => {
  try {
    const response = await checkSlugApi(slug)
    return response.data.length === 0
  } catch {
    return false
  }
}

export const generateAndValidateSlug = async (
  name: string,
  checkSlugApi: (slug: string) => Promise<any>,
): Promise<{ slug: string; isUnique: boolean }> => {
  let baseSlug = removeAccents(name)
  let slug = baseSlug
  let counter = 1

  while (true) {
    const isUnique = await isSlugUnique(slug, checkSlugApi)
    if (isUnique) {
      return { slug, isUnique: true }
    }
    slug = `${baseSlug}-${counter}`
    counter++
    
    if (counter > 100) {
      slug = `${baseSlug}-${Date.now()}`
      break
    }
  }

  return { slug, isUnique: true }
}
